import { Card, Typography, message, Space, Button, Form, Row, Col } from "antd";
import { useEffect, useState } from "react";
import { getExperiencia, changeExperiencia } from "../../api/experiencias";
import { CheckOutlined, EditOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
const { Text } = Typography;

const validator = {
  descricao: [{ required: true, message: "Informe as suas experiências!" }],
};

const HomeExperiencias = () => {
  const [dados, setDados] = useState("");
  const [loading, setLoading] = useState(false);
  const [editable, setEditable] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    carregarExperiencia();
  }, []);

  const carregarExperiencia = async () => {
    setLoading(true);
    try {
      const retorno = await getExperiencia();
      if (retorno?.statusCode === 200) {
        const response = retorno?.response?.data;
        setDados(response?.descricao ?? "");
        form.setFieldValue("descricao", response?.descricao ?? "");
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const alterarExperiencia = async (formulario) => {
    setLoading(true);
    try {
      const retorno = await changeExperiencia(formulario);
      if (retorno?.statusCode === 200) {
        message.success("Registro alterado com sucesso!");
        form.setFieldValue("descricao", formulario?.descricao ?? "");
        setDados(formulario?.descricao ?? "");
        setEditable(false);
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  return (
    <Card title={<Text className="title-middle">Experiências</Text>} className="shadow">
      <Space direction="vertical" className="full-width">
        <Text type="secondary">Adicione um resumo de suas experiências profissionais.</Text>
        <Form
          className={editable ? "" : "hidden"}
          form={form}
          onFinish={alterarExperiencia}
          layout="vertical"
          autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={24}>
              <Form.Item name="descricao" hasFeedback rules={validator?.descricao}>
                <TextArea
                  placeholder="Faça um resumo sobre suas experiências profissionais."
                  disabled={loading}
                  autoSize={{ minRows: 5, maxRows: 20 }}
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item noStyle>
                <Button htmlType="submit" loading={loading} icon={<CheckOutlined />} size="large" type="primary" block>
                  Salvar
                </Button>
              </Form.Item>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item noStyle>
                <Button
                  onClick={() => {
                    setEditable(false);
                    form.setFieldValue("descricao", dados);
                  }}
                  loading={loading}
                  size="large"
                  type="text"
                  block>
                  Cancelar
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Space className={editable ? "full-width hidden" : "full-width"} direction="vertical" size={20}>
          <Text className="line-break" onClick={() => setEditable(true)}>
            {dados ? dados : "Faça um resumo sobre suas experiências profissionais."}
          </Text>
          <Button
            loading={loading}
            icon={editable ? <CheckOutlined /> : <EditOutlined />}
            size="large"
            type="dashed"
            block
            onClick={() => (editable ? alterarExperiencia(dados) : setEditable(!editable))}>
            {editable ? "Salvar" : "Editar"}
          </Button>
        </Space>
      </Space>
    </Card>
  );
};

export { HomeExperiencias };
